// extracted by mini-css-extract-plugin
export default {"example":"trackingCodeTooltip_example__2WdDc","section-body":"trackingCodeTooltip_section-body__wNf4Z"};